'use es6';

import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { range } from 'underscore';
import { connect } from 'react-redux';
import PromotingMenuDropTarget from 'simple-menus-lib/components/dnd/components/PromotingMenuDropTarget';
import * as applicationSelectors from 'simple-menus-core/selectors/application';
import { jsx as _jsx } from "react/jsx-runtime";
function makeMapStateToProps() {
  return function mapStateToProps(state) {
    return {
      isDragging: applicationSelectors.getIsDragging(state)
    };
  };
}
const HOC = Component => {
  const WithPromotingMenuDropTargets = /*#__PURE__*/forwardRef((props, ref) => {
    const {
      hasChildren,
      isLastChild,
      moveNodeAction,
      isParentDragging,
      id,
      hierarchy,
      depthToNextSibling = 0,
      depth: isNested = 0,
      isDragging,
      menuId,
      readOnly
    } = props;
    const renderDropTargets = () => {
      if (hasChildren || !isLastChild || !isNested || !isDragging) return null;
      return range(depthToNextSibling).map(depth => {
        const targetIndex = hierarchy.length - (depthToNextSibling - depth);
        return /*#__PURE__*/_jsx(PromotingMenuDropTarget, {
          depth: depth,
          moveNode: moveNodeAction,
          isParentDragging: isParentDragging,
          id: id,
          targetId: hierarchy[targetIndex],
          targetParentId: hierarchy[targetIndex - 1],
          menuId: menuId,
          readOnly: readOnly
        }, depth);
      });
    };
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      ref: ref,
      dropTargets: renderDropTargets()
    }));
  });
  WithPromotingMenuDropTargets.propTypes = {
    isOver: PropTypes.bool,
    depth: PropTypes.number.isRequired,
    isLastChild: PropTypes.bool,
    hasChildren: PropTypes.bool,
    depthToNextSibling: PropTypes.number,
    hasSibling: PropTypes.bool,
    moveNode: PropTypes.func.isRequired,
    isParentDragging: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    hierarchy: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
    isDragging: PropTypes.bool,
    menuId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    moveNodeAction: PropTypes.func.isRequired,
    readOnly: PropTypes.bool
  };
  WithPromotingMenuDropTargets.displayName = `WithPromotingMenuDropTargets(${Component.displayName || Component.name || 'Component'})`;
  return connect(makeMapStateToProps, null)(WithPromotingMenuDropTargets);
};
export default function withPromotingMenuDropTargets() {
  return HOC;
}